import React from "react";
import Navbar from "./NavBar";
import Herobg2 from "../assets/bgbus.png";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {

  const navigate = useNavigate();
  return (
    <div
      className="relative min-h-screen bg-top bg-no-repeat bg-cover flex flex-col"
      style={{
        backgroundImage: `url(${Herobg2})`,
      }}
    >
   
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent z-0" />


  {/* Fixed Navbar */}
      <div className="fixed top-0 left-0 w-full z-50 backdrop-blur-md bg-black/0 border-b border-white/5">
        <Navbar />
      </div>

   <div className="relative z-10 flex-grow flex items-center justify-start  px-10">
  <div className="max-w-2xl text-left">

    {/* Small Label */}
    <p className="text-green-400 uppercase tracking-[0.35em] text-xs sm:text-sm font-medium mb-4 font-['Barlow_Semi_Condensed']">
      India's Next Generation EV Mobility
    </p>

    {/* Main Heading */}
    <h1
      className="text-3xl sm:text-3xl md:text-4xl lg:text-5xl leading-[0.95] text-white drop-shadow-2xl"
      style={{ fontFamily: "'Racing Sans One', sans-serif" }}
    >
      OHM   { "  "} AUTOMOTIVES
    </h1>


    <p
      className="mt-5 text-xl sm:text-2xl md:text-3xl text-white/90 tracking-wide"
      style={{ fontFamily: "'Barlow Semi Condensed', sans-serif" }}
    >
      Powering Every Journey With Intelligent Electric Mobility
    </p>

    {/* Description */}
    <p
      className="mt-7 text-base sm:text-lg md:text-xl text-gray-300 leading-relaxed max-w-2xl font-light"
      style={{ fontFamily: "'Roboto', sans-serif" }}
    >
      Proudly pioneering the future of clean transit with   <span className="text-green-400 font-medium">
        India's first
      commercial electric buses
        </span>  engineered using advanced
      <span className="text-green-400 font-medium">
        {" "}BC5 CATL battery technology
      </span>
      , delivering performance, efficiency, and sustainable mobility at scale.
    </p>

    {/* Buttons */}
    <div className="mt-10 flex flex-wrap gap-5">

      <button
      
        onClick={() => navigate("/electricBus")}
        className="bg-green-500 hover:bg-green-400 text-black font-semibold uppercase tracking-[0.2em] text-sm px-9 py-4 rounded-md transition-all duration-300 shadow-2xl hover:scale-105">
        Explore Products
      </button>

      <button
      
        onClick={() => navigate("/contact")}
      className="border border-white/20 backdrop-blur-md hover:bg-white/10 text-white uppercase tracking-[0.2em] text-sm px-9 py-4 rounded-md transition-all duration-300">
        Contact Us
      </button>

    </div>

  </div>
</div>
    </div>
  );
}